import {
  BaseEdge,
  EdgeProps,
  getSmoothStepPath,
  Position,
} from '@xyflow/react';

import { flowUtilConsts } from '../utils/consts';
import { ApLoopCloseEdge } from '../utils/types';

export const ApLoopCloseCanvasEdge = ({
  sourceX,
  sourceY,
  targetX,
  targetY,
}: EdgeProps & ApLoopCloseEdge) => {
  const sourcePosition = Position.Bottom;
  const targetPosition = Position.Left;
  const [edgePath] = getSmoothStepPath({
    sourceX,
    sourceY: sourceY + 20,
    sourcePosition,
    targetX: targetX + 10,
    targetY: targetY + 10,
    targetPosition,
    borderRadius: 20,
  });
  return (
    <BaseEdge
      path={edgePath}
      style={{ strokeWidth: `${flowUtilConsts.LINE_WIDTH}px` }}
      className="animated-edge"
    ></BaseEdge>
  );
};
